import { CreateBotFromEasyTradeForm } from '@models/Bot/CreateBotFromEasyTradeForm'

export const initialEasyTradeValues: CreateBotFromEasyTradeForm = {
  easyTradeId: null,
  symbols: [],
  totalInvestment: 0,
}
